import { useState, useEffect } from "react";
import { NavLink, useParams} from 'react-router-dom';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import apiService from '../../Auth/apiService.jsx';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import MenuCaracterizacion from "../Caracterizacion/Componentes/MenuCaracterizacion.jsx";
import CustomInput from "../Utils/CustomInput2.jsx";
import { FaEraser, FaHandPointLeft } from "react-icons/fa";
import { useAuth } from "../../Auth/AuthContext.jsx";
import VulneracionHomicidio from "./VulneracionHomicidio.jsx";
import VulneracionVssexual from "./VulneracionVssexual.jsx";
import VulneracionTrata from "./VulneracionTrata.jsx";
import VulneracionLider from "./VulneracionLider.jsx";
import VulneracionBusqueda from "./VulneracionBusqueda.jsx";
import VulneracionReclutamiento from "./VulneracionReclutamiento.jsx";
import confirmarConToast from "../Utils/confirmarConToast.jsx";

function AccionesVulneraciones(row, SeleccionarVulneracion, BorrarVulneracion, rol) {
        return (
            <div>
                <button type="button" onClick={() => SeleccionarVulneracion(row)} 
                        style={{backgroundColor: 'white', border: 'none', cursor: 'pointer'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Seleccionar">
                    <FaHandPointLeft size={20} color="black" />
                </button>
                {rol === '2' && <button type="button" onClick={() => BorrarVulneracion(row)} 
                        style={{backgroundColor: 'white', border: 'none', cursor: 'pointer'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Borrar">
                    <FaEraser size={20} color="black" />
                </button>}
            </div>
        );
    }
export default function Vulneraciones(){
    const { token, user, rol, nombre } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [accordionVulneracionesExpanded, setAccordionVulneracionesExpanded] = useState(true);
    const { idCabezaFamilia } = useParams();
    const [tipoVulneraciones, setTipoVulneraciones] = useState([]);
    const [tipoVulneracionesSeleccionadas, setTipoVulneracionesSeleccionadas] = useState([]);
    const [vulneraciones, setVulneraciones] = useState([]);
    const [municipiosdto, setMunicipiosdto] = useState([]);
    const [modulosDdhh, setModulosDdhh] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [estadoCasos, setEstadoCasos] = useState([]);
    const [paises, setPaises] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const SeleccionarVulneracion = async (row) => {
        let url = '';
        url = `/ddhh/vulneraciones/obtenervulneracion/${row.id}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            if(result?.vulneracion){
                filtrarTiposVulneracionesPorModulo(result.vulneracion.intModuloddhhid);
                reset((prevValues) => ({
                    ...prevValues,
                    ...result,
                }));
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    async function BorrarVulneracion(row){
        const confirmDelete = await confirmarConToast({
            message: '¿Está seguro de que desea eliminar esta vulneración? Esto puede eliminar todas las atenciones relacionadas según el módulo al que pertenezca.',
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            type: 'warn',
        });
        console.log('Confirm delete:', confirmDelete);
        if (!confirmDelete) {
            return;
        }
        setCargando(true);
        let url = '';
        url = '/ddhh/vulneraciones/borrarvulneracion';
        const obj = {id: row.id, intModuloddhhid: row.int_moduloddhhid, usrId: user};
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                await ConsultarVulneraciones(idCabezaFamilia);
                Mensaje('Borrar vulneraciones', 'Registro borrado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Borrar vulneraciones', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Borrar vulneraciones', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const {register, control, handleSubmit, getValues, watch, setValue, reset, formState: { errors }} = useForm({
        defaultValues: {
            vulneracion: {
                id: 0,
                intUserid: user,
                cabIdcabezafamilia: idCabezaFamilia,
            },
            datosVulneracion: {
                strProfesionalAtencion: nombre,
            },
            redesContacto: []
        }
      });
    const { append, remove } = useFieldArray({
        control,
        name: 'redesContacto'
    });
    function CrearNuevaVulneracion(){
        setAccordionVulneracionesExpanded(false);
        reset((prevValues) => ({
            ...prevValues,
            vulneracion: {
                id: 0,
                intUserid: user,
                cabIdcabezafamilia: idCabezaFamilia,
                strIdpersona: '',
                intModuloddhhid: '',
                intTiposvulneracionid: '',
                intEstadocasoid: '',
                datFechahecho: '',
                timHorahecho: '',
                intMunicipioid: '',
                intBarriohecho: '',
                strBarriootromunicipio: '',
                strRelatohecho: '',
                strDireccionhecho: ''
            },
            datosVulneracion: {
                strProfesionalAtencion: nombre,
            },
            redesContacto: []
        }))
        
    }
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const Mensaje = (title, text, tipo = 'info') => {
        const mensaje = `${title}: ${text}`;
        if (tipo === 'success') {
            toast.success(mensaje);
            return;
        }
        if (tipo === 'error') {
            toast.error(mensaje);
            return;
        }
        toast.info(mensaje);
    };
    const onSubmit = async (data) => {
        setCargando(true);
        let url = '';
        if((data.vulneracion.id == '0')){
            url = '/ddhh/vulneraciones/guardavulneracion';
        } else {
            url = '/ddhh/vulneraciones/actualizarvulneracion';
        }
        try {
            data.vulneracion.intUserid = user;
            data.vulneracion.cabIdcabezafamilia = idCabezaFamilia;
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                await ConsultarVulneraciones(idCabezaFamilia);
                CrearNuevaVulneracion();
                Mensaje('Guardar vulneraciones', response.data.message, 'success');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar vulneraciones', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Guardar vulneraciones', JSON.stringify(error.response.data), 'error');
            }else{
                Mensaje('Guardar vulneraciones', 'Error, consulte con el administrador', 'error');
            }
            console.error('Error fetching data:', error);
        } finally {
          setCargando(false);
        }
      };
    async function ConsultarVulneraciones(idCabezaFamilia){
        const url = `/ddhh/vulneraciones/consultarvulneraciones/${idCabezaFamilia}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setVulneraciones(result.vulneraciones);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            const url = '/ddhh/vulneraciones/crearformulariovulneraciones';
            const obj = {idCabezaFamilia: idCabezaFamilia}
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setEstadoCasos(result.estadoCasos || []);
                setCabezaFamiliaDatos(result.cabezafamilia);
                setMunicipiosdto(result.municipiosdto);
                setBarrios(result.barrios);
                setTipoVulneraciones(result.tipoVulneraciones);
                setVulneraciones(result.vulneraciones);
                setPaises(result.paises || []);
                setModulosDdhh(result.modulosDdhh || []);
                setPersonas(result.grupoFamiliar || []);
                setParentescos(result.parentescos || []);
                setTiposDocumento(result.tiposDocumentos || []);
            } catch (error) {
               console.error('Error fetching data:', error);
            } finally {
              setCargando(false);
            }
        };
        fetchData();
    }, [idCabezaFamilia, token]);
    const moduloSeleccionado = watch('vulneracion.intModuloddhhid');
    const moduloSeleccionadoNombre = modulosDdhh
        .find(m => String(m.id) === String(moduloSeleccionado))?.str_nombre?.toLowerCase() ?? '';
    const esHomicidio = moduloSeleccionadoNombre.includes('homicidio');
    const esVssexual = moduloSeleccionadoNombre.includes('sexual');
    const esTrata = moduloSeleccionadoNombre.includes('trata');
    const esLider = moduloSeleccionadoNombre.includes('lider');
    const esBusqueda = moduloSeleccionadoNombre.includes('busqueda');
    const esReclutamiento = moduloSeleccionadoNombre.includes('reclut');
    function filtrarTiposVulneracionesPorModulo(idModulo){
        const moduloId = Number(idModulo);
        setTipoVulneracionesSeleccionadas(
            tipoVulneraciones.filter(tv => Number(tv.int_moduloddhhid) === moduloId));
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Vulneraciones DDHH {moduloSeleccionadoNombre}</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Vulneraciones DDHH</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                    <Accordion
                        expanded={accordionVulneracionesExpanded}
                        onChange={(_, isExpanded) => setAccordionVulneracionesExpanded(isExpanded)}
                    >
                        <AccordionSummary
                        expandIcon={<ArrowDownwardIcon style={{ color: 'white' }} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        style={{ backgroundColor: '#007bff', color: 'white' }}
                        >
                        <Typography>Ver todas las vulneraciones registradas <b>(dar click para mostrar las vulneraciones registradas)</b></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="float-sm-right">
                                        <button type="button" className="btn btn-primary" onClick={CrearNuevaVulneracion}>Nuevo</button>
                                </div>
                            </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id Persona</th>
                                            <th>Nombre Persona</th>
                                            <th>Id Registro</th>
                                            <th>Vulneraci&oacute;n</th>
                                            <th>Fecha Vulneraci&oacute;n</th>
                                            <th>Hora Vulneraci&oacute;n</th>
                                            <th>Tipo</th>
                                            <th>Municipio</th>
                                            <th>Barrio Vulneraci&oacute;n</th>
                                            <th>Usuario</th>
                                            <th>Relato Vulneraci&oacute;n</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vulneraciones.length === 0 ? (
                                            <tr>
                                                <td colSpan="17" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            vulneraciones.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>
                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                            <button
                                                                type="button"
                                                                onClick={() => SeleccionarVulneracion(row)}
                                                                style={{
                                                                    backgroundColor: 'skyblue',
                                                                    color: 'black', // Font color black
                                                                    padding: '6px 12px',         // Smaller padding
                                                                    fontSize: '1rem',            // Smaller font size
                                                                    borderRadius: '6px',         // Slightly smaller radius
                                                                    border: 'none',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                data-tooltip-id='tooltiparriba'
                                                                data-tooltip-content="Seleccionar"
                                                            >
                                                                <FaHandPointLeft size={20} color="black" />
                                                            </button>
                                                            {rol === '2' && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => BorrarVulneracion(row)}
                                                                    style={{
                                                                        backgroundColor: 'skyblue',
                                                                        color: 'black', // Font color black
                                                                        padding: '6px 12px',         // Smaller padding
                                                                        fontSize: '1rem',            // Smaller font size
                                                                        borderRadius: '6px',         // Slightly smaller radius
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Borrar"
                                                                >
                                                                    <FaEraser size={20} color="black" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{row.str_idpersona ?? '-'}</td>
                                                    <td>{row.nombrepersona ?? '-'}</td>
                                                    <td>{row.id ?? '-'}</td>
                                                    <td>{row.tipoVulneracion ?? '-'}</td>
                                                    <td>{row.dat_fechahecho ?? '-'}</td>
                                                    <td>{row.tim_horahecho ?? '-'}</td>
                                                    <td>{row.moduloDDHH ?? '-'}</td>
                                                    <td>{row.municipioHecho ?? '-'}</td>
                                                    <td>{row.barrioHecho ?? row.str_barriootromunicipio ?? '-'}</td>
                                                    <td>{row.usuario ?? '-'}</td>
                                                    <td>{row.str_relatohecho ?? '-'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                    <div className="col-md-12">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card">
                                <div className="card-body">
                                    <input hidden {...register('vulneracion.intUserid')}/>
                                    <input hidden {...register('vulneracion.cabIdcabezafamilia')}/>
                                    <input hidden {...register('vulneracion.id')}/>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.intModuloddhhid">Linea de vulnerabilidad</label>
                                                <select id="vulneracion.intModuloddhhid" className="form-control" 
                                                    {...register('vulneracion.intModuloddhhid', {
                                                        onChange: (e) => {
                                                            filtrarTiposVulneracionesPorModulo(e.target.value);
                                                        }
                                                    }, { required: true })}>
                                                    <option value="">Seleccione...</option>
                                                    {modulosDdhh.map((option, idx) => (
                                                        <option key={option.id || idx} value={option.id}>{option.str_nombre}</option>
                                                    ))}
                                                </select>
                                                {errors.vulneracion?.intModuloddhhid && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.strIdpersona">Id persona</label>
                                                <select id="vulneracion.strIdpersona" className="form-control" {...register('vulneracion.strIdpersona', { required: true })}>
                                                    <option value="">Seleccione...</option>
                                                    {personas
                                                        .filter((option) => {
                                                            if (!esHomicidio) {
                                                                return true;
                                                            }
                                                            return option.per_fallecido === 'SI';
                                                        })
                                                        .map((option, idx) => (
                                                        <option key={option.perIdpersona} value={option.perIdpersona}>{option.perIdpersona} {option.per_nombre1} {option.per_nombre2 || ''} {option.per_apellido1 || ''} {option.per_apellido2 || ''}</option>
                                                    ))}
                                                </select>
                                                {errors.vulneracion?.strIdpersona && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.intTiposvulneracionid">Tipo vulneraci&oacute;n</label>
                                                <select id="vulneracion.intTiposvulneracionid" className="form-control" 
                                                    {...register('vulneracion.intTiposvulneracionid', { required: true })}>
                                                    <option value="">Seleccione...</option>
                                                    {tipoVulneracionesSeleccionadas.map((option, idx) => (
                                                        <option key={option.id || idx} value={option.id}>{option.str_nombre}</option>
                                                    ))}
                                                </select>
                                                {errors.vulneracion?.intTiposvulneracionid && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    <label htmlFor="vulneracion.datFechahecho">Fecha hecho</label>
                                                    <Controller
                                                        control={control}
                                                        name="vulneracion.datFechahecho"
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0] : '')}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value ? new Date(`${field.value}T12:00:00`) : null}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                            />
                                                        )}
                                                    />
                                                    {errors.vulneracion?.datFechahecho && <span className="text-danger">Este campo es obligatorio</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.timHorahecho">Hora hecho</label>
                                                <input id="vulneracion.timHorahecho" type="time" className="form-control" {...register('vulneracion.timHorahecho', { required: true })} />
                                                {errors.vulneracion?.timHorahecho && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='vulneracion.intEstadocasoid'>Estado del caso</label>
                                            <select id='vulneracion.intEstadocasoid' {...register('vulneracion.intEstadocasoid', { required: true })} className='form-control'>
                                                <option value="">Seleccione...</option>
                                                {estadoCasos.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.str_nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.vulneracion?.intEstadocasoid && <p style={{color: 'red'}}>Seleccione estado de caso</p>}
                                        </div>
                                    </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.intMunicipioid">Municipio hecho</label>
                                                <select 
                                                    id="vulneracion.intMunicipioid" 
                                                    className="form-control" 
                                                    {...register('vulneracion.intMunicipioid', { required: true })}
                                                    onSelect={(e) => {
                                                        const municipioId = e.target.value;
                                                        setValue('vulneracion.intBarriohecho', '');
                                                        setValue('vulneracion.strBarriootromunicipio', '');
                                                        setValue('vulneracion.intMunicipioid', municipioId);
                                                    }}
                                                    >
                                                    <option value="">Seleccione...</option>
                                                    {municipiosdto.map((option, idx) => (
                                                        <option key={option.id || idx} value={option.id}>{option.mun_municipio}</option>
                                                    ))}
                                                </select>
                                                {errors.vulneracion?.intMunicipioid && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                        {watch('vulneracion.intMunicipioid') == '1' && <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.intBarriohecho">Barrio hecho</label>
                                                <select id="vulneracion.intBarriohecho" className="form-control" {...register('vulneracion.intBarriohecho')}>
                                                    <option value="">Seleccione...</option>
                                                    {barrios.map((option, idx) => (
                                                        <option key={option.id || idx} value={option.id}>{option.bar_barrio || option.nombre || option.mun_nombre || option.id}</option>
                                                    ))}
                                                </select>
                                                {errors.vulneracion?.intBarriohecho && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.strDireccionhecho">Direcci&oacute;n del hecho</label>
                                                <input
                                                    id="vulneracion.strDireccionhecho"
                                                    type="text"
                                                    className="form-control"
                                                    {...register('vulneracion.strDireccionhecho' , { required: true })}
                                                />
                                                {errors.vulneracion?.strDireccionhecho && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                        {watch('vulneracion.intMunicipioid') != '1' && <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.strBarriootromunicipio">Barrio otro municipio</label>
                                                <input type="text" id="vulneracion.strBarriootromunicipio" className="form-control" {...register('vulneracion.strBarriootromunicipio')} />
                                                {errors.vulneracion?.strBarriootromunicipio && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="vulneracion.strRelatohecho">Relato hecho</label>
                                                <textarea id="vulneracion.strRelatohecho" rows="3" className="form-control" {...register('vulneracion.strRelatohecho')} />
                                                {errors.vulneracion?.strRelatohecho && <span className="text-danger">Este campo es obligatorio</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {esHomicidio && <VulneracionHomicidio 
                                register={register} 
                                watch={watch}
                                setValue={setValue}
                                getValues={getValues}
                                append={append}
                                remove={remove}
                                parentescos={parentescos} 
                                errors={errors} 
                                useAuth={useAuth} 
                                apiService={apiService} 
                                Cargando={Cargando} 
                                setCargando={setCargando} 
                                idCabezaFamilia={idCabezaFamilia} 
                                user={user} 
                                token={token} 
                                Mensaje={Mensaje}
                                paises={paises}
                                barrios={barrios}
                                municipiosdto={municipiosdto}
                                tiposDocumentos={tiposDocumento} />}
                            {esVssexual && <VulneracionVssexual 
                                register={register} 
                                watch={watch} 
                                parentescos={parentescos} 
                                errors={errors} 
                                useAuth={useAuth} 
                                apiService={apiService} 
                                Cargando={Cargando} 
                                setCargando={setCargando} 
                                idCabezaFamilia={idCabezaFamilia} 
                                user={user} 
                                token={token} 
                                Mensaje={Mensaje}
                                setValue={setValue}
                                getValues={getValues}
                                append={append}
                                remove={remove}
                                paises={paises} 
                                barrios={barrios}
                                municipiosdto={municipiosdto}
                                tiposDocumentos={tiposDocumento}
                                 />}
                            {esTrata && <VulneracionTrata 
                                register={register} 
                                setValue={setValue}
                                getValues={getValues}
                                watch={watch}
                                append={append}
                                remove={remove}
                                parentescos={parentescos} 
                                errors={errors} 
                                useAuth={useAuth} 
                                apiService={apiService} 
                                Cargando={Cargando} 
                                setCargando={setCargando} 
                                idCabezaFamilia={idCabezaFamilia} 
                                user={user} 
                                token={token} 
                                Mensaje={Mensaje} 
                                municipiosdto={municipiosdto} 
                                paises={paises}
                                barrios={barrios}
                                tiposDocumentos={tiposDocumento}
                                />}
                            {esLider && <VulneracionLider 
                                register={register} 
                                setValue={setValue} 
                                watch={watch}
                                user={user} 
                                control={control} 
                                errors={errors} 
                                useAuth={useAuth} 
                                apiService={apiService} 
                                Cargando={Cargando} 
                                setCargando={setCargando} 
                                idCabezaFamilia={idCabezaFamilia} 
                                token={token} 
                                Mensaje={Mensaje} />}
                            {esBusqueda && <VulneracionBusqueda 
                                register={register} 
                                setValue={setValue} 
                                getValues={getValues}
                                user={user} 
                                personas={personas} 
                                errors={errors} 
                                useAuth={useAuth} 
                                apiService={apiService} 
                                Cargando={Cargando} 
                                setCargando={setCargando} 
                                idCabezaFamilia={idCabezaFamilia} 
                                token={token} 
                                Mensaje={Mensaje} />}
                            {esReclutamiento && <VulneracionReclutamiento 
                                apiService={apiService} 
                                token={token} 
                                register={register} 
                                setValue={setValue} 
                                watch={watch} 
                                user={user} 
                                errors={errors} 
                                setCargando={setCargando} 
                                />}
                            <div className="card">
                                <div className="card-footer">
                                    <button type="submit" className="btn btn-primary">Guardar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    </div>
                </div>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}